import { ReactNode } from "react";
import {
  FormProvider as Form,
  SubmitHandler,
  UseFormReturn,
} from "react-hook-form";

type Props = {
  children: ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  methods: UseFormReturn<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit?: SubmitHandler<any>;
  className?: string;
  id?: string;
};

export const RhfFormProvider = ({
  children,
  onSubmit,
  methods,
  id,
  className,
}: Props): JSX.Element => {
  return (
    <Form {...methods}>
      <form
        onSubmit={
          onSubmit &&
          ((e) => {
            e.preventDefault();
            void methods.handleSubmit(onSubmit)(e);
          })
        }
        id={id}
        className={className}
      >
        {children}
      </form>
    </Form>
  );
};
